// Include polyfills required to support our browserlist
// https://create-react-app.dev/docs/supported-browsers-features/
// https://github.com/facebook/create-react-app/blob/main/packages/react-app-polyfill/README.md
import 'react-app-polyfill/stable';

// File required for Module Federation
// @see https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
import('./bootstrap');
export {};
